import Relay from 'react-relay';
import { withRouter } from 'react-router';
import App from '../app';
import fragments from '../app/fragments';
import DeckWrapper from './deck-wrapper';

export default (product, path, actionPipe) => {
  return withRouter(Relay.createContainer(DeckWrapper(App(product, actionPipe), path), fragments));
};



// WEBPACK FOOTER //
// ./src/components/questionnaire/index.js